module.exports = __webpack_public_path__ + "70a3dc02fa0917f9f9e433e585ff3583.jpg";